"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
exports.__esModule = true;
exports.ColdArticleEntity = void 0;
var utils_1 = require("@lglp/utils");
var types_1 = require("../../../../types");
var constants_1 = require("../../../constants");
var field_groups_1 = require("../../../field-groups");
var article_factory_1 = require("./article-factory");
exports.ColdArticleEntity = article_factory_1.articleFactory(types_1.PageType.COLD_ARTICLE, function (prismicDoc, normalizedArticle, logger) {
    var _a;
    var _b, _c;
    return utils_1.compact(__assign(__assign({}, normalizedArticle), { banner: field_groups_1.toBanner(utils_1.unprefix('header', prismicDoc.data), logger), filters: utils_1.compact((_a = {},
            _a[types_1.Filter.Localization] = constants_1.toLocalizationFilter((_b = prismicDoc === null || prismicDoc === void 0 ? void 0 : prismicDoc.data) === null || _b === void 0 ? void 0 : _b.localization, logger),
            _a[types_1.Filter.Thematic] = constants_1.toThematic((_c = prismicDoc === null || prismicDoc === void 0 ? void 0 : prismicDoc.data) === null || _c === void 0 ? void 0 : _c.thematic, logger),
            _a)) }));
});
//# sourceMappingURL=cold-article.js.map